import { render, staticRenderFns } from "./screen-card-team.vue?vue&type=template&id=9eb98800&scoped=true"
import script from "./screen-card-team.vue?vue&type=script&lang=ts"
export * from "./screen-card-team.vue?vue&type=script&lang=ts"
import style0 from "./screen-card-team.vue?vue&type=style&index=0&id=9eb98800&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb98800",
  null
  
)

export default component.exports